import React from 'react';
import { TItemsTab } from 'shared/types/types';
import { RolesUser } from 'shared/enums';
import { useAppDispatch, useAppSelector } from 'app/store';
import { Button, Tabs } from 'antd';
import { viewerModel } from 'entities/viewer';
import { useTabsNavigate } from 'shared/hooks';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { OvertimeStatuses } from 'shared/enums/overtime';
import { overtimeActions } from 'entities/overtime/model/Overtime';
import { PICKER_DATE_MASK } from 'shared/constants';
import { TOvertime } from 'shared/types/overtime.types';
import { configTabs } from 'shared/helpers/utils';
import { uiModel } from 'entities/ui';
import { RvdTabs } from 'features/rvd';
import style from './index.module.scss';
import OvertimePull from './overtimePull/OvertimePull';
import OvertimeArchive from './overtimeArchive/OvertimeArchive';
import OvertimeSubstitutions from './overtimeSubstitutions/OvertimeSubstitutions';
import OvertimeInProgress from './overtimeInProgress/OvertimeInProgress';
import OvertimeSubstitutionArchive from './overtimeSubstitutionArchive/OvertimeSubstitutionArchive';

const Overtime = () => {
  const { role } = useAppSelector(viewerModel.me.selectors.selectViewerProfile);
  const { active } = useAppSelector(uiModel.Tabs.selectors.selectTabs);

  const [activeTab, handler] = useTabsNavigate(
    'overtime',
    (Object.values(RvdTabs).includes(active as RvdTabs) && active) || 'new',
  );
  const dispatch = useAppDispatch();

  const onCreateButtonClick = () => {
    const overtime: TOvertime = {
      id: Date.now(),
      created: moment().format(PICKER_DATE_MASK),
      count: 0,
      status: OvertimeStatuses.NOT_LOADED_CPRODUCT,
      employees: [],
      docSignatory: '',
    };
    dispatch(overtimeActions.setCurrent(overtime));
  };

  const itemsTab: TItemsTab = [
    {
      label: 'Общий список заявок',
      key: 'new',
      children: <OvertimePull />,
      role: [RolesUser.HRDirector, RolesUser.SecondLine],
    },
    {
      label: 'Подчинённые',
      key: 'other',
      children: <OvertimeSubstitutions />,
      role: [RolesUser.HRDirector, RolesUser.SecondLine],
    },
    {
      label: 'В работе',
      key: 'my',
      children: <OvertimeInProgress />,
      role: [RolesUser.HRDirector, RolesUser.SecondLine],
    },

    {
      label: 'Архив',
      key: 'myArchive',
      children: <OvertimeArchive />,
      role: [RolesUser.HRDirector, RolesUser.SecondLine],
    },
    {
      label: 'Архив подчиненных',
      key: 'otherArchive',
      children: <OvertimeSubstitutionArchive />,
      role: [RolesUser.HRDirector, RolesUser.SecondLine],
    },
  ];
  const tabPane = configTabs(role, itemsTab);

  return (
    <>
      <div className={style.buttons}>
        <h3 className={style.title}>Сверхурочная работа</h3>
        <Link to="/overtime/new">
          <Button type="primary" onClick={onCreateButtonClick}>
            Добавить заявку
          </Button>
        </Link>
      </div>

      <div className={style.wrap}>
        {/* To do: задать роли! */}
        {role && <Tabs activeKey={activeTab} onChange={handler} destroyInactiveTabPane items={tabPane}></Tabs>}
      </div>
    </>
  );
};

export default Overtime;
